import { useRouteError, useNavigate } from 'react-router-dom';

export default function RouteError() {
  const error = useRouteError();
  const navigate = useNavigate();

  console.error('Router error:', error);

  return (
    <div
      style={{
        height: '100vh',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        textAlign: 'center',
        padding: '20px'
      }}
    >
      <h2 style={{ marginBottom: '10px' }}>⚠ Something went wrong</h2>
      <p style={{ marginBottom: '25px', maxWidth: '400px' }}>{error?.statusText || error?.message}</p>

      <div>
        <button style={{ marginRight: '10px' }} className="btn btn-primary" onClick={() => navigate(-1)}>
          Go Back
        </button>

        <button style={{ marginLeft: '10px' }} className="btn btn-secondary ms-2" onClick={() => navigate('/')}>
          Home
        </button>
      </div>
    </div>
  );
}
